export default "__VITE_ASSET__BTkpswoA__"